export function TextoUltraRapido() {
  return (
    <h1>Em desenvolvimento</h1>
  )
}